import { render, staticRenderFns } from "./orderPayList.vue?vue&type=template&id=0ba7cb8e&scoped=true&"
import script from "./orderPayList.vue?vue&type=script&lang=js&"
export * from "./orderPayList.vue?vue&type=script&lang=js&"
import style0 from "./orderPayList.vue?vue&type=style&index=0&id=0ba7cb8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba7cb8e",
  null
  
)

export default component.exports